export default __webpack_public_path__ + "sagemaker_studio_logo.ec2d60b5.png";